import { environment } from "@web/config/environment";
import { getBusinessConfig } from "@web/config/business-config";

function resolveUploadUrl(value: string | null | undefined, folder: string) {
  const clean = value?.trim();
  const uploadBaseUrl = getBusinessConfig().uploadBaseUrl || environment.uploadBaseUrl;
  if (!clean) return undefined;
  if (/^https?:\/\//i.test(clean)) {
    try {
      const url = new URL(clean);
      if (url.pathname.startsWith("/uploads/")) {
        const uploadOrigin = uploadBaseUrl.replace(
          /\/uploads\/?$/,
          "",
        );
        return `${uploadOrigin}${url.pathname}${url.search}${url.hash}`;
      }
    } catch {
      return clean;
    }
    return clean;
  }
  if (clean.startsWith("/uploads/")) {
    return `${uploadBaseUrl.replace(/\/uploads\/?$/, "")}${clean}`;
  }
  if (clean.startsWith("profile-images/") || clean.startsWith("properties/")) {
    return `${uploadBaseUrl}/${clean}`;
  }
  return `${folder}/${clean.replace(/^\/+/, "")}`;
}

export const profileImageUrl = (value?: string | null) =>
  resolveUploadUrl(value, `${getBusinessConfig().uploadBaseUrl}/profile-images`);

export const propertyImageUrl = (value?: string | null) =>
  resolveUploadUrl(value, `${getBusinessConfig().uploadBaseUrl}/properties`);
